var _style, _path, _rect, _polyline, _path2, _path3, _path4, _path5, _path6, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsNocontent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#CDCDCD;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#ECECEA;}\n\t.st4{fill:url(#SVGID_2_);}\n\t.st5{fill:#F7F7F7;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.7572,
    y1: 57.945,
    x2: 319.1431,
    y2: 417.3093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6605,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAEAEA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.5,436.9L94.9,338.4c-7.4-3.4-10.5-12.2-7.1-19.5L217.5,40.2c3.4-7.4,12.2-10.5,19.5-7.1l211.7,98.5 c7.4,3.4,10.5,12.2,7.1,19.5L326.1,429.8C322.6,437.2,313.9,440.4,306.5,436.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 158.8,
    y: 90.3,
    transform: "matrix(0.9066 0.422 -0.422 0.9066 124.7493 -92.1841)",
    className: "st1",
    width: 223.8,
    height: 290.8
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "205.7,365.9 107.8,320.4 230.6,56.7 433.4,151.1 368,291.6  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.7,365.8c13,2.5,52.2,8.5,95.1-11.9c40.5-19.2,60.5-50.6,67.2-62.3c21.8-46.8,43.6-93.7,65.4-140.5 L230.6,56.7L107.8,320.4L205.7,365.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M311.3,361.4c-9.2,5.1-24.8,12.1-45.3,14.1c-28,2.8-49.8-5.1-60.2-9.7c10.1-0.8,35.1-4.3,58.7-23 c31.2-24.8,37.9-58.9,39.4-67.6c2.6,5.7,7.6,14.8,17.1,23c2.3,2,4.5,3.6,6.7,5.1c8.2,5.4,18.8,6,27.3,1c0.1,0,0.1-0.1,0.2-0.1 c11.4-6.8,14.3-18.5,14.9-20.8c-2.3,9.5-6.6,22.3-14.9,35.7C340.8,342.3,321.9,355.2,311.3,361.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161.1,105.6c-5.8,1.7-15.3,3.6-27,2.2c-15.9-2-27.1-9.1-32.3-13c5.8,0.8,20.1,2,35.6-5.5 c20.5-9.9,28.5-28.1,30.5-32.7c0.7,3.5,2.4,9.2,6.6,15c1,1.4,2,2.6,3.1,3.7c3.9,4.1,9.7,5.7,15.1,4c0,0,0.1,0,0.1,0 c7.2-2.4,10.3-8.5,10.9-9.7c-2.5,5-6.5,11.6-12.8,18C179.9,98.7,167.8,103.6,161.1,105.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.9933,
    y1: 93.6558,
    x2: 425.4643,
    y2: 93.6558
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6605,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAEAEA"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M400.9,151.2L257,85.5c-1.7-0.8-2.5-2.9-1.7-4.6L275,37.8c0.8-1.7,2.9-2.5,4.6-1.7l143.8,65.7 c1.7,0.8,2.5,2.9,1.7,4.6l-19.7,43.1C404.7,151.2,402.6,152,400.9,151.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144,155.5c-3.9,6.2-15.7,23.1-38.7,32.7c-23.1,9.6-43.5,6-50.5,4.5c7.7,9.9,18.8,22.3,34.2,34.2 c11.4,8.8,22.6,15.4,32.6,20.2c11.2,5.5,23.3,9.2,35.7,10.4c3.8,0.4,7.8,0.6,12,0.6c46.5,0.1,80-26.4,92.2-37.2 c-7.5,1.8-37.9,8.1-69.9-8.9C157.6,193.8,146.3,162.3,144,155.5z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 244.4,
    cy: 469.2,
    rx: 179.9,
    ry: 11.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsNocontent);
export default __webpack_public_path__ + "static/media/es-nocontent.87eda9c0674cdb10fd812294512dcac3.svg";
export { ForwardRef as ReactComponent };